if (!window.YesoulPolicyNavigation) {
  window.YesoulPolicyNavigation = class {
    constructor({root, nav, links, headings}) {
      this.root = root;
      this.nav = nav;
      this.links = links;
      this.headings = headings;
      this.anchors = [...links.querySelectorAll('a[href^="#"]')];
      this.controller = new AbortController();
      this.manualUntil = 0;
      const {signal} = this.controller;
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.measure = () => {
        const size = matchMedia('(max-width: 999px)').matches ? nav.offsetHeight : 0;
        root.style.setProperty('--ys-policy-nav-height', `${size}px`);
        root.style.setProperty('--ys-warranty-nav-size', `${size}px`);
        this.queue();
      };
      const manual = () => { this.manualUntil = performance.now() + 1800; };
      links.addEventListener('pointerdown', () => { this.dragging = true; manual(); }, {passive: true, signal});
      window.addEventListener('pointerup', () => { this.dragging = false; }, {passive: true, signal});
      window.addEventListener('pointercancel', () => { this.dragging = false; }, {passive: true, signal});
      links.addEventListener('touchstart', manual, {passive: true, signal});
      links.addEventListener('wheel', manual, {passive: true, signal});
      links.addEventListener('keydown', event => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) manual();
      }, {signal});
      root.addEventListener('click', event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (!anchor || !root.contains(anchor) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = headings.find(heading => `#${heading.id}` === anchor.hash);
        if (!target) return;
        event.preventDefault();
        this.manualUntil = 0;
        this.dragging = false;
        const top = window.scrollY + target.getBoundingClientRect().top - this.offset();
        window.scrollTo({top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        target.focus({preventScroll: true});
        history.replaceState(null, '', anchor.hash);
        this.mark(target.id);
      }, {signal});
      window.addEventListener('scroll', this.queue, {passive: true, signal});
      window.addEventListener('resize', this.measure, {passive: true, signal});
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(this.measure);
        this.resize.observe(nav);
      }
      this.measure();
    }
    offset() {
      const header = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      return header + (matchMedia('(max-width: 999px)').matches ? this.nav.offsetHeight : 0) + 24;
    }
    sync() {
      if (!this.root.isConnected || !this.headings.length) return;
      const offset = this.offset();
      let current = this.headings[0];
      for (const heading of this.headings) {
        if (heading.getBoundingClientRect().top <= offset + 2) current = heading;
      }
      this.mark(current.id);
    }
    mark(id) {
      let active;
      for (const anchor of this.anchors) {
        if (anchor.hash === `#${id}`) { anchor.setAttribute('aria-current', 'location'); active = anchor; }
        else anchor.removeAttribute('aria-current');
      }
      if (!active || !matchMedia('(max-width: 999px)').matches || this.dragging || performance.now() < this.manualUntil) return;
      const outer = this.links.getBoundingClientRect();
      const inner = active.getBoundingClientRect();
      const delta = inner.left < outer.left + 4 ? inner.left - outer.left - 4
        : inner.right > outer.right - 4 ? inner.right - outer.right + 4 : 0;
      if (delta) this.links.scrollBy({left: delta, behavior: 'instant'});
    }
    disconnect() {
      this.controller.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  };
}
